export default __webpack_public_path__ + "static/media/LOGO_americ.21be83a2.png";